import React from 'react';
import { XCircle } from 'lucide-react';
import { Card, CardContent } from '../Components/ui/card';

export default function Blacklist() {
  return (
    <div className="max-w-[1600px] mx-auto">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <div className="flex items-center space-x-3">
          <div className="bg-gradient-to-br from-red-500 to-red-600 p-3 rounded-lg">
            <XCircle className="h-6 w-6 text-white" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Blacklist</h1>
            <p className="text-sm text-gray-500">Manage blacklisted candidates</p>
          </div>
        </div>
      </div>
      <Card className="mt-6 shadow-sm">
        <CardContent className="text-center py-12">
          <XCircle className="h-12 w-12 text-gray-400 mx-auto mb-4" />
          <p className="text-gray-500">No blacklisted candidates</p>
        </CardContent>
      </Card>
    </div>
  );
}